module.exports = __webpack_public_path__ + "static/media/health-and-disease-anxiety.e8949b21.png";